import React, { useEffect } from "react";
import FormModal from "../../components/FormModal/FormModal";
import { withRouter } from "react-router";
import Logo from "../../components/TopHeader/Logo/Logo";
import successIcon from "../../assets/images/tick-icon.png";
import "./SucessPage.scss";
import { useCartContext } from "../../lib/CartContext/CartContext";
const SuccessPage = (props) => {
  const orderId = props.match.params.slug;
  const cartCtx = useCartContext();

  useEffect(() => {
    localStorage.removeItem("woo-session");
    cartCtx.refetch();
    const timer = setTimeout(() => {
      if (orderId) {
        props.history.push(`/porosite/${orderId}`);
      } else {
        props.history.push(`/`);
      }
    }, 4000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="SuccessPage">
      <FormModal>
        <div className="SuccessPage__content">
          <Logo />
          <div className="SuccessPage__success">
            <img src={successIcon} alt="Succes Icon" />
            <p>Porosia juaj është procesuar me sukses. Faleminderit!</p>
          </div>
        </div>
      </FormModal>
    </div>
  );
};

export default withRouter(SuccessPage);
